import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Noticing the Automatic Rejection",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I only notice — I don’t fix."
    ],
      [
      "Daily intention: Today I only notice — I don’t fix."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “Something good came to me — and I don’t have to push it away.”"
    ],
      [
      "I pause with myself.",
      "One slow breath.",
      "In my heart: “Something good came to me — and I don’t have to push it away.”"
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. How do I usually respond to a compliment or recognition? (dismiss / joke / change the subject)\n[Write here]",
      "2. What do I feel in my body the moment someone says something good about me?\n[Write here]",
      "3. What inner sentence immediately appears?\n[Write here]"
    ],
      [
      "1. How do I usually respond to a compliment or recognition? (dismiss / joke / change the subject)\n[Write here]",
      "2. What do I feel in my body the moment someone says something good about me?\n[Write here]",
      "3. What inner sentence immediately appears?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "My reaction is a habit — not a truth."
    ],
      [
      "Closing",
      "My reaction is a habit — not a truth."
    ]
    ),
    action: localizedGenderNode(
      "Once today: when something good comes — I simply notice what happens inside me.",
      "Once today: when something good comes — I simply notice what happens inside me."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What’s Scary About Receiving",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I check what truly feels threatening about receiving."
    ],
      [
      "Daily intention: Today I check what truly feels threatening about receiving."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What scares me about letting a compliment enter?\n[Write here]",
      "2. What thought comes immediately after a compliment? (\"They’re exaggerating,\" \"It’s not real\")\n[Write here]",
      "3. What do I fear would happen if I believed it?\n[Write here]"
    ],
      [
      "1. What scares me about letting a compliment enter?\n[Write here]",
      "2. What thought comes immediately after a compliment? (\"They’re exaggerating,\" \"It’s not real\")\n[Write here]",
      "3. What do I fear would happen if I believed it?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Sometimes the fear is exposure — not deception."
    ],
      [
      "Closing",
      "Sometimes the fear is exposure — not deception."
    ]
    ),
    action: localizedGenderNode(
      "One breath + the sentence: “I’m allowed to feel uncomfortable.”",
      "One breath + the sentence: “I’m allowed to feel uncomfortable.”"
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "The Habit of Shrinking",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I recognize self-minimizing — without judgment."
    ],
      [
      "Daily intention: Today I recognize self-minimizing — without judgment."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What words do I use to minimize myself?\n[Write here]",
      "2. Where did I learn that it’s “dangerous” to stand out?\n[Write here]",
      "3. What is this trying to protect me from?\n[Write here]"
    ],
      [
      "1. What words do I use to minimize myself?\n[Write here]",
      "2. Where did I learn that it’s “dangerous” to stand out?\n[Write here]",
      "3. What is this trying to protect me from?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Minimizing is an old form of protection."
    ],
      [
      "Closing",
      "Minimizing is an old form of protection."
    ]
    ),
    action: localizedGenderNode(
      "When I minimize — I simply say: “I noticed.”",
      "When I minimize — I simply say: “I noticed.”"
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "Compliment ≠ Obligation",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I separate receiving from pressure."
    ],
      [
      "Daily intention: Today I separate receiving from pressure."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What obligation do I imagine comes with a compliment?\n[Write here]",
      "2. Does a compliment actually obligate me to anything?\n[Write here]",
      "3. What calming thought is possible?\n[Write here]"
    ],
      [
      "1. What obligation do I imagine comes with a compliment?\n[Write here]",
      "2. Does a compliment actually obligate me to anything?\n[Write here]",
      "3. What calming thought is possible?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Receiving does not require perfection."
    ],
      [
      "Closing",
      "Receiving does not require perfection."
    ]
    ),
    action: localizedGenderNode(
      "Sentence: “A compliment is a moment, not a contract.”",
      "Sentence: “A compliment is a moment, not a contract.”"
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "Achievements I Never Counted",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I count what never got applause."
    ],
      [
      "Daily intention: Today I count what never got applause."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Three things I achieved — and never stopped to acknowledge\n[Write here]",
      "2. Why did I dismiss them?\n[Write here]",
      "3. How does it feel to see them written?\n[Write here]"
    ],
      [
      "1. Three things I achieved — and never stopped to acknowledge\n[Write here]",
      "2. Why did I dismiss them?\n[Write here]",
      "3. How does it feel to see them written?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Not every achievement needs an audience."
    ],
      [
      "Closing",
      "Not every achievement needs an audience."
    ]
    ),
    action: localizedGenderNode(
      "Write one achievement in my journal — and close it.",
      "Write one achievement in my journal — and close it."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "“It Was Just Luck”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I examine the luck story."
    ],
      [
      "Daily intention: Today I examine the luck story."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. When do I say “it was just luck”?\n[Write here]",
      "2. What part of me was actually involved?\n[Write here]",
      "3. How does minimal recognition sound — without arrogance?\n[Write here]"
    ],
      [
      "1. When do I say “it was just luck”?\n[Write here]",
      "2. What part of me was actually involved?\n[Write here]",
      "3. How does minimal recognition sound — without arrogance?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Acknowledging effort is not inflation."
    ],
      [
      "Closing",
      "Acknowledging effort is not inflation."
    ]
    ),
    action: localizedGenderNode(
      "One sentence: “There was something of me in this.”",
      "One sentence: “There was something of me in this.”"
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Experiment: Just “Thank You”",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t explain. I don’t dismiss."
    ],
      [
      "Daily intention: Today I don’t explain. I don’t dismiss."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What’s harder for me — saying “thank you” or staying silent?\n[Write here]",
      "2. What arises in me when I only say thank you?\n[Write here]",
      "3. What didn’t happen despite the fear?\n[Write here]"
    ],
      [
      "1. What’s harder for me — saying “thank you” or staying silent?\n[Write here]",
      "2. What arises in me when I only say thank you?\n[Write here]",
      "3. What didn’t happen despite the fear?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Simplicity can be safe."
    ],
      [
      "Closing",
      "Simplicity can be safe."
    ]
    ),
    action: localizedGenderNode(
      "One compliment → only “thank you.”",
      "One compliment → only “thank you.”"
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "Allowing Discomfort (ACT)",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I stay with the feeling for one minute."
    ],
      [
      "Daily intention: Today I stay with the feeling for one minute."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What feeling arises when I receive something good?\n[Write here]",
      "2. One-minute practice: I let the feeling be — without action.\n[Write here]",
      "3. What happened after the minute?\n[Write here]"
    ],
      [
      "1. What feeling arises when I receive something good?\n[Write here]",
      "2. One-minute practice: I let the feeling be — without action.\n[Write here]",
      "3. What happened after the minute?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Discomfort doesn’t kill — it passes."
    ],
      [
      "Closing",
      "Discomfort doesn’t kill — it passes."
    ]
    ),
    action: localizedGenderNode(
      "One minute only.",
      "One minute only."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Receiving Without Comparison",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I receive without comparing."
    ],
      [
      "Daily intention: Today I receive without comparing."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Who do I compare this compliment to?\n[Write here]",
      "2. What is the cost of that comparison?\n[Write here]",
      "3. How does it feel to keep this with myself?\n[Write here]"
    ],
      [
      "1. Who do I compare this compliment to?\n[Write here]",
      "2. What is the cost of that comparison?\n[Write here]",
      "3. How does it feel to keep this with myself?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "What’s good for me doesn’t take from anyone else."
    ],
      [
      "Closing",
      "What’s good for me doesn’t take from anyone else."
    ]
    ),
    action: localizedGenderNode(
      "One comparison stop today.",
      "One comparison stop today."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Self-Worth Without Proof",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I check who I am without proving."
    ],
      [
      "Daily intention: Today I check who I am without proving."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What am I trying to prove by rejecting compliments?\n[Write here]",
      "2. What happens if I prove nothing?\n[Write here]",
      "3. What steady sentence do I choose?\n[Write here]"
    ],
      [
      "1. What am I trying to prove by rejecting compliments?\n[Write here]",
      "2. What happens if I prove nothing?\n[Write here]",
      "3. What steady sentence do I choose?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "My worth doesn’t depend on defense."
    ],
      [
      "Closing",
      "My worth doesn’t depend on defense."
    ]
    ),
    action: localizedGenderNode(
      "Return to the steady sentence once.",
      "Return to the steady sentence once."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Receiving Without Apologizing",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I notice unnecessary apologies."
    ],
      [
      "Daily intention: Today I notice unnecessary apologies."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. Where do I apologize when I don’t need to?\n[Write here]",
      "2. What do I fear people will think of me?\n[Write here]",
      "3. What does receiving without apologizing look like?\n[Write here]"
    ],
      [
      "1. Where do I apologize when I don’t need to?\n[Write here]",
      "2. What do I fear people will think of me?\n[Write here]",
      "3. What does receiving without apologizing look like?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Quiet receiving is maturity."
    ],
      [
      "Closing",
      "Quiet receiving is maturity."
    ]
    ),
    action: localizedGenderNode(
      "Once today — don’t apologize.",
      "Once today — don’t apologize."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "Changing Inner Language",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I change one word."
    ],
      [
      "Daily intention: Today I change one word."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What minimizing word do I use after success?\n[Write here]",
      "2. How does the same truth sound in humane language?\n[Write here]",
      "3. What new word do I choose?\n[Write here]"
    ],
      [
      "1. What minimizing word do I use after success?\n[Write here]",
      "2. How does the same truth sound in humane language?\n[Write here]",
      "3. What new word do I choose?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Words build a home."
    ],
      [
      "Closing",
      "Words build a home."
    ]
    ),
    action: localizedGenderNode(
      "One replacement only.",
      "One replacement only."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "Letting Good Stay",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I don’t rush to erase the good."
    ],
      [
      "Daily intention: Today I don’t rush to erase the good."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What happens inside me when I let good stay for a moment?\n[Write here]",
      "2. What value does this serve in me?\n[Write here]",
      "3. What do I promise myself when rejection arises?\n[Write here]"
    ],
      [
      "1. What happens inside me when I let good stay for a moment?\n[Write here]",
      "2. What value does this serve in me?\n[Write here]",
      "3. What do I promise myself when rejection arises?\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Closing",
      "Good can be stable."
    ],
      [
      "Closing",
      "Good can be stable."
    ]
    ),
    action: localizedGenderNode(
      "Pause 10 seconds with something good.",
      "Pause 10 seconds with something good."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Gentle Closure",
    opening: localizedGenderNode(
      [
      "Daily intention: Today I finish without changing who I am."
    ],
      [
      "Daily intention: Today I finish without changing who I am."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "One breath."
    ],
      [
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "1. What has changed in how I meet compliments?\n[Write here]",
      "2. What feels slightly less threatening now?\n[Write here]",
      "3. Return sentence for hard days:\n[Write here]"
    ],
      [
      "1. What has changed in how I meet compliments?\n[Write here]",
      "2. What feels slightly less threatening now?\n[Write here]",
      "3. Return sentence for hard days:\n[Write here]"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Final closure",
      "I don’t have to push good away.",
      "I can let it be.",
      "I stay with myself —",
      "and that is enough."
    ],
      [
      "Final closure",
      "I don’t have to push good away.",
      "I can let it be.",
      "I stay with myself —",
      "and that is enough."
    ]
    ),
    action: localizedGenderNode(
      "One action that symbolizes quiet receiving (breath / writing / walk).",
      "One action that symbolizes quiet receiving (breath / writing / walk)."
    ),
  },
].map(buildNormalizedDay);

export const difficultyReceivingComplimentsAchievementsBlueprintEn = buildNormalizedPilotBlueprint({
  id: "difficulty_receiving_compliments_achievements_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "difficulty_receiving_compliments_achievements",
  category: "general",
  journeyName: {
    he: "קושי לקבל מחמאות והישגים",
    en: "Difficulty Receiving Compliments and Achievements",
    es: "Dificultad para Recibir Halagos y Logros",
  },
  days,
});

export default difficultyReceivingComplimentsAchievementsBlueprintEn;
